import { accessEventsConstants } from "../_constants";

export function listAccessEvents(state = {}, action) {
  switch (action.type) {
    case accessEventsConstants.GETALL_ACCESS_EVENTS_REQUEST:
      return {
        loading: true,
      };
    case accessEventsConstants.GETALL_ACCESS_EVENTS_SUCCESS:
      return {
        items: action.accessEvents,
      };
    case accessEventsConstants.GETALL_ACCESS_EVENTS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function listEventStatus(state = {}, action) {
  switch (action.type) {
    case accessEventsConstants.GET_EVENT_ACCESS_STATUS_REQUEST:
      return {
        loading: true,
      };
    case accessEventsConstants.GET_EVENT_ACCESS_STATUS_SUCCESS:
      return {
        items: action.events,
      };
    case accessEventsConstants.GET_EVENT_ACCESS_STATUS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function filtersAccessEvents(state = {}, action) {
  switch (action.type) {
    case accessEventsConstants.GET_EVENT_ACCESS_FILTERS_REQUEST:
      return {
        loading: true,
      };
    case accessEventsConstants.GET_EVENT_ACCESS_FILTERS_SUCCESS:
      return {
        items: action.filtersAudit,
      };
    case accessEventsConstants.GET_EVENT_ACCESS_FILTERS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function accessEventsTopCards(state = {}, action) {
  switch (action.type) {
    case accessEventsConstants.GET_ACCESS_EVENTS_TOP_CARDS_REQUEST:
      return {
        loading: true,
      };
    case accessEventsConstants.GET_ACCESS_EVENTS_TOP_CARDS_SUCCESS:
      return {
        items: action.accessEventsTopCards,
      };
    case accessEventsConstants.GET_ACCESS_EVENTS_TOP_CARDS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
